/**
 * PayPal Message Updater
 * Updates the data-pp-amount attribute when variant changes or quantity updates
 */

(function () {
	class PayPalMessageUpdater {
		constructor() {
			this.ppMessageElement = document.querySelector("[data-pp-message]");

			if (!this.ppMessageElement) return;

			this.init();
		}

		init() {
			// Find the product section
			this.productSection = document.querySelector(".product.section");

			if (!this.productSection) return;

			// Find the price element
			this.priceElement = this.productSection.querySelector(
				".product-price .money"
			);

			// Find the quantity input
			this.quantityInput = this.productSection.querySelector(
				"[data-product-quantity-input]"
			);

			if (!this.priceElement) return;

			// Listen for variant change events
			this.productSection.addEventListener("variantChange", (event) => {
				// Get the variant from the event
				const variant = event.detail.variant;

				// Use the variant price directly instead of reading from DOM
				if (variant && variant.price) {
					this.updateAmountFromVariant(variant);
				} else {
					// Fallback to DOM if variant price is not available
					// Add a small delay to ensure DOM is updated
					setTimeout(() => this.updateAmount(), 300);
				}
			});

			// Listen for quantity change events
			document.addEventListener(
				"theme:section:product:quantity-sync",
				this.updateAmount.bind(this)
			);

			// Initial update
			this.updateAmount();
		}

		// New method to update amount directly from variant data
		updateAmountFromVariant(variant) {
			if (!this.ppMessageElement) return;

			// Get price directly from variant
			let price = variant.price / 100; // Convert cents to dollars/euros

			// Get the current quantity
			const quantity = this.quantityInput
				? parseInt(this.quantityInput.value, 10)
				: 1;

			// Calculate the total price
			const totalPrice = price * quantity;

			// Update the data-pp-amount attribute
			this.ppMessageElement.setAttribute(
				"data-pp-amount",
				totalPrice.toFixed(2)
			);

			// Force PayPal to refresh the message
			if (typeof paypal !== "undefined" && paypal.Messages) {
				paypal.Messages().refresh();
			}
		}

		updateAmount() {
			if (!this.ppMessageElement) return;

			// Re-query the price element to ensure we have the latest DOM reference
			this.priceElement = this.productSection.querySelector(
				".product-price .money"
			);

			if (!this.priceElement) {
				return;
			}
			
			// Get the current price from the price element
			// Format is typically "1,49 €"
			const priceText = this.priceElement.textContent.trim();

			// Extract the numeric part and convert to a number
			// Replace comma with dot for proper decimal parsing
			let price = parseFloat(
				priceText.replace(/[^0-9,]/g, "").replace(",", ".")
			);

			// Get the current quantity
			const quantity = this.quantityInput
				? parseInt(this.quantityInput.value, 10)
				: 1;

			// Calculate the total price
			const totalPrice = price * quantity;

			// Update the data-pp-amount attribute
			// Format with 2 decimal places and ensure it uses dot as decimal separator
			this.ppMessageElement.setAttribute(
				"data-pp-amount",
				totalPrice.toFixed(2)
			);

			// Force PayPal to refresh the message
			if (typeof paypal !== "undefined" && paypal.Messages) {
				paypal.Messages().refresh();
			}
		}
	}

	// Initialize on DOMContentLoaded
	document.addEventListener("DOMContentLoaded", () => {
		new PayPalMessageUpdater();
	});

	// Also initialize when the cart drawer is opened (for quick view products)
	document.addEventListener("theme:cart:open", () => {
		new PayPalMessageUpdater();
	});
})();
